import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import moment from '../../../lib/moment.js'
import { Container, Row, Col } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
  companyAction,
  lobAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
  companySelector,
  lobSelector,
} from './../../../selectors'
import { searchYearOfService } from '../../../function'
import Searchbar from '../../../components/searchbar-report/year-of-service'
import withLayout from '../../../helpers/withLayout'
import YearOfServiceTable from '../../../components/table-year-of-service'
import { FONTS } from '../../../constants'

class YearOfServiceReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getYearOfServiceData')) {
      set(tempState, 'year_of_service', get(nextProps, 'getYearOfServiceData.data'))
      set(tempState, 'default_year_of_service', get(nextProps, 'getYearOfServiceData.data'))
      set(tempState, 'meta', get(nextProps, 'getYearOfServiceData.meta'))
      nextProps.resetGetYearOfService()
    }
    if (get(nextProps, 'getCompanyData')) {
      const list = [{ _id: '', name: 'Choose Company' }]
      list.push(...get(nextProps, 'getCompanyData'))
      set(tempState, 'companys', list)
      nextProps.resetGetCompany()
    }
    if (get(nextProps, 'getLOBData')) {
      const list = [{ _id: '', name: 'Choose LOB' }]
      list.push(...get(nextProps, 'getLOBData'))
      set(tempState, 'default_lobs', list)
      set(tempState, 'lobs', [{ _id: '', name: 'Choose LOB' }])
      nextProps.resetGetLOB()
    }
    if (get(nextProps, 'exportYearOfServiceData')) {
      window.open(get(nextProps, 'exportYearOfServiceData'))
      nextProps.resetExportYearOfService()
    }
    return tempState
  }
  constructor(props) {
    super(props)
    this.state = {
      default_year_of_service: [],
      year_of_service: [],
      meta: null,
      companys: [],
      default_lobs: [],
      lobs: [],
      selectedCompany: '',
      selectedLOB: '',
      date: moment(),
      search: '',
      sort_by: 'emp_code',
      sort_order: 'desc',
    }
    this.handleCompany = this.handleCompany.bind(this)
    this.handleLOB = this.handleLOB.bind(this)
    this.handleChangeDate = this.handleChangeDate.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.sortBy = this.sortBy.bind(this)
    this.export = this.export.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getYearOfService(moment().format('YYYY-MM-DD'), access_token)
    this.props.getCompany(access_token)
    this.props.getLOB(access_token)
  }

  handleChangeDate(newDate) {
    this.setState({ date: newDate })
    const access_token = localStorage.getItem('access_token')
    this.props.getYearOfService(moment(newDate).format('YYYY-MM-DD'), access_token)
  }

  handleCompany(e) {
    if (e.target.value === '') {
      this.setState({
        selectedCompany: '',
        selectedLOB: '',
        year_of_service: this.state.default_year_of_service,
        lobs: [{ _id: '', name: 'Choose LOB' }],
      })
    } else {
      const newYOS = this.state.default_year_of_service.filter((element) => {
        return element.company_id === e.target.value
      })
      const newLOB = this.state.default_lobs.filter((element) => {
        return element.company_id === e.target.value
      })
      const company = find(this.state.companys, {
        _id: e.target.value,
      })
      this.setState({
        selectedCompany: company._id,
        year_of_service: newYOS,
        lobs: [{ _id: '', name: 'Choose LOB' }, ...newLOB],
      })
    }
  }

  handleLOB(e) {
    if (e.target.value !== '') {
      const newYOS = this.state.default_year_of_service.filter((element) => {
        return element.company_id === this.state.selectedCompany
        && element.lob_id === e.target.value
      })
      const lob = find(this.state.lobs, {
        _id: e.target.value,
      })
      this.setState({
        selectedLOB: lob._id,
        year_of_service: newYOS,
      })
    } else {
      const newYOS = this.state.default_year_of_service.filter((element) => {
        return element.company_id === this.state.selectedCompany
      })
      this.setState({
        selectedLOB: '',
        year_of_service: newYOS,
      })
    }
  }

  handleClickSearch() {
    let yos = get(this.state, 'default_year_of_service').filter(searchYearOfService, this.state.search)
    if (this.state.selectedCompany !== '') {
      yos = yos.filter((element) => {
        return element.company_id === this.state.selectedCompany
      })
    }
    if (this.state.selectedLOB !== '') {
      yos = yos.filter((element) => {
        return element.lob_id === this.state.selectedLOB
      })
    }
    this.setState({
      year_of_service: yos,
    })
  }

  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') {
      let newYOS = this.state.default_year_of_service
      if (this.state.selectedCompany !== '') {
        newYOS = newYOS.filter((element) => {
          return element.company_id === this.state.selectedCompany
        })
      }
      if (this.state.selectedLOB !== '') {
        newYOS = newYOS.filter((element) => {
          return element.lob_id === this.state.selectedLOB
        })
      }
      if (this.state.selectedCompany === '' && this.state.selectedLOB === '') {
        this.setState({
          year_of_service: this.state.default_year_of_service,
          search: '',
        })
      } else {
        this.setState({
          year_of_service: newYOS,
          search: '',
        })
      }
    } else this.setState({ search: e.target.value })
  }

  sortBy(type, order) {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }

  sortYearOfService(data) {
    if (this.state.sort_by === 'emp_code') return orderBy(data, ['emp_code'], [this.state.sort_order])
    else if (this.state.sort_by === 'name') return orderBy(data, ['first_name', 'last_name'], [this.state.sort_order])
    else if (this.state.sort_by === 'company_name') return orderBy(data, ['company_name'], [this.state.sort_order])
    else if (this.state.sort_by === 'lob_name') return orderBy(data, ['lob_name'], [this.state.sort_order])
    else if (this.state.sort_by === 'department_name') return orderBy(data, ['department_name'], [this.state.sort_order])
    else if (this.state.sort_by === 'hiring_date') return orderBy(data, ['hiring_date'], [this.state.sort_order])
    else if (this.state.sort_by === 'year_of_service') return orderBy(data, ['year_of_service_year', 'year_of_service_month'], [this.state.sort_order, this.state.sort_order])
    return data
  }

  export() {
    const access_token = localStorage.getItem('access_token')
    this.props.exportYearOfService(this.state.date, access_token)
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsHRUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsSystemUser !== undefined &&
      IsPMUser !== undefined &&
      !(IsSystemUser || IsLOBLeadUser || IsHRUser || IsHRConfidentialUser || IsManagementUser || IsPMUser)) window.location = '/home'
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          { ...this.state }
          export={ this.export }
          handleCompany={ this.handleCompany }
          handleLOB={ this.handleLOB }
          handleChangeDate={ this.handleChangeDate }
          handleSearch={ this.handleSearch }
        />
        <DivSummary>
          <Block>
            <Text>{`${get(this.state, 'meta.year0_1', '')}`} People</Text>
            <TextNumberOfYear>0-1 Year of Service</TextNumberOfYear>
          </Block>
          <Divider />
          <Block>
            <Text>{`${get(this.state, 'meta.year2_4', '')}`} People</Text>
            <TextNumberOfYear>2-4 Year of Service</TextNumberOfYear>
          </Block>
          <Divider />
          <Block>
            <Text>{`${get(this.state, 'meta.year5_9', '')}`} People</Text>
            <TextNumberOfYear>5-9 Year of Service</TextNumberOfYear>
          </Block>
          <Divider />
          <Block>
            <Text>{`${get(this.state, 'meta.year10_14', '')}`} People</Text>
            <TextNumberOfYear>10-14 Year of Service</TextNumberOfYear>
          </Block>
          <Divider />
          <Block>
            <Text>{`${get(this.state, 'meta.year15', '')}`} People</Text>
            <TextNumberOfYear>15+ Year of Service</TextNumberOfYear>
          </Block>
        </DivSummary>
        <Row noGutters>
          <Col>
            { isFetching &&
            <Overlay>
              <OverlayWrapper>
                <BeatLoader
                  css={ css(`
                    position: absolute;
                    left: 50%;
                    top: 50%;
                  `) }
                  sizeUnit={ "px" }
                  size={ 15 }
                  color={ '#D44B49' }
                  loading={ isFetching }
                />
              </OverlayWrapper>
            </Overlay>
            }
            <YearOfServiceTable
              { ...this.state }
              yos={ this.sortYearOfService(this.state.year_of_service) }
              sortBy={ this.sortBy }
            />
          </Col>
        </Row>
      </Wrapper>
    )
  }
}
YearOfServiceReport.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getYearOfService: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  exportYearOfService: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  getYearOfServiceData: reportSelector.getYearOfServiceData,
  exportYearOfServiceData: reportSelector.exportYearOfServiceData,
  getIsFetching: reportSelector.getIsFetching,
  getCompanyData: companySelector.getListCompany,
  getLOBData: lobSelector.getListLOB,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getYearOfService: reportAction.getYearOfServiceReport,
  resetGetYearOfService: reportAction.resetGetYearOfServiceReport,
  exportYearOfService: reportAction.exportYearOfServiceReport,
  resetExportYearOfService: reportAction.resetExportYearOfServiceReport,
  getCompany: companyAction.getCompany,
  resetGetCompany: companyAction.resetListCompany,
  getLOB: lobAction.getLOB,
  resetGetLOB: lobAction.resetListLOB,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(YearOfServiceReport))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
const DivSummary = styled.div`
  background-color: #FFFFFF;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin: 10px;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Text = styled.p`
  color: #AD2624;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.HEADER_SIZE};
  margin-bottom: 10px;
`
const TextNumberOfYear = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 10px;
`
const Divider = styled.div`
  height: 80px;
  width: 1px;
  margin: 10px;
  border-left: 1px solid #E5E5E5;
`



// WEBPACK FOOTER //
// ./src/pages/report/year-of-service/index.js